import { getRequest } from 'helpers/axios';

export const getQuestionResponse = (templateId) => {
  return getRequest(`questions?search[template_slug_eq]=${templateId}`);
};
